import { Typography } from '@material-ui/core';
import { useMemo } from 'react';

export const QuickTitle = ({ title, subTitle = 'Advanced Filters' }) => (
  <>
    <Typography variant="h5">{title}</Typography>
    <Typography variant="body2" color="textSecondary">
      {subTitle}
    </Typography>
    <br />
  </>
);

export const addTitleToFilter =
  (Filter: any, title?: string, subTitle = 'Advanced Filters') =>
  props => {
    const actualTitle = useMemo(
      () => title || props.column.render('Header'),
      [props.column.Header]
    );
    return (
      <>
        <QuickTitle title={actualTitle} subTitle={subTitle} />
        <Filter {...props} />
      </>
    );
  };
